/*
 * @Desc: 相关api
 * @Author: zcc
 * @Date: 2022-11-22 13:59:48
 * @LastEditors: zcc
 * @LastEditTime: 2022-11-22 17:40:38
 */
import request from '@/utils/request'
const common = `/api/v1/`
// 获取用户信息
export function getUserInfo() {
  return request({
    url: common + `user`,
    method: 'GET'
  })
}
// 用code换取Token
export function getCodeToken(data) {
  return request({
    url: common + `auth/internalUserToken`,
    method: 'POST',
    data
  })
}
// 登出
export function logout(data) {
  return request({
    url: common + `auth/logoutCtl`,
    method: 'POST',
    data
  })
}
